import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core';
import { ConfirmationModalComponent } from './core/components/confirmation-modal';
import { VersionUpdateNotificationComponent } from './core/components/version-update-notification/version-update-notification.component';
import { LeaveWithUnsavedChangesService } from './core/services/leave-with-unsaved-changes.service';
import { FooterComponent } from './main/components/footer/footer.component';
import { HeaderComponent } from './main/components/header/header.component';
import { NavigationComponent } from './main/components/navigation/navigation.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    NavigationComponent,
    VersionUpdateNotificationComponent,
    ConfirmationModalComponent
  ],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  private readonly authService = inject(AuthService);
  protected readonly leaveWithUnsavedChanges = inject(LeaveWithUnsavedChangesService);

  protected readonly isAuthenticated = this.authService.isAuthenticated;
}
